/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-07-11
 */

import React from "react";
import { RecentDonorsDefault } from "./RecentDonorsDefault";
import { RecentDonorsMobile } from "./RecentDonorsMobile";

export const RecentDonors: React.FC = () => {
    return(
        <>
            {(window.innerWidth < 768) &&
                <RecentDonorsMobile endpoint={"transactions/recent"} recordCount={30} />
            }
            
            {(window.innerWidth >= 768) &&
                <RecentDonorsDefault endpoint={"transactions/recent"} recordCount={30} />
            }
        </>
    );
}